import { Box, Button, Typography } from '@mui/material';
import { Trans, useTranslation } from 'react-i18next';
import ModalCard from '../ui/ModalCard';
import StatusIconCircle from '../ui/StatusIconCircle';
import InfoCallout from '../ui/InfoCallout';
import { MailCheckIcon } from '../icons';

interface RegisterCheckEmailCardProps {
  email: string;
  onChangeEmail: () => void;
}

export default function RegisterCheckEmailCard({ email, onChangeEmail }: RegisterCheckEmailCardProps) {
  const { t } = useTranslation();

  return (
    <ModalCard title={t('register.cardTitle')}>
      <StatusIconCircle icon={<MailCheckIcon size={24} />} variant="accent" />

      <Typography variant="h3" component="h1">
        {t('register.checkEmail.headline')}
      </Typography>

      <Typography variant="body2" sx={{ color: 'text.secondary' }}>
        <Trans
          i18nKey="register.checkEmail.description"
          values={{ email }}
          components={{ strong: <Box component="span" sx={{ color: 'text.primary', fontWeight: 600 }} /> }}
        />
      </Typography>

      <InfoCallout title={t('register.checkEmail.hintTitle')} body={t('register.checkEmail.hintBody')} />

      <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2 }}>
        <Button
          type="button"
          variant="contained"
          fullWidth
          onClick={onChangeEmail}
          sx={(theme) => ({
            backgroundColor: theme.app.primary,
            color: theme.app.primaryForeground,
            '&:hover': { backgroundColor: theme.app.primaryHover },
          })}
        >
          {t('register.checkEmail.changeEmail')}
        </Button>
      </Box>
    </ModalCard>
  );
}
